
export default {
  permissions: {
    granted: 'granted',
    denied: 'denied',
    default: 'default',
    unsupported: 'unsupported',
  },
  isSupported() {
    return 'Notification' in window;
  },

  async requestPermission() {
    if (!this.isSupported()) return this.permissions.unsupported;

    let perm = Notification.permission; // "granted" | "denied" | "default"

    if (Notification.permission !== this.permissions.granted && Notification.permission !== this.permissions.denied) {
      perm = await Notification.requestPermission();
    }

    return perm;
  },

  async isAllowed() {
    if (!this.isSupported()) return false;

    const perm = await this.requestPermission();
    return perm === this.permissions.granted;
  },

  async showNotification(title, options = {}) {
    if (!this.isSupported()) return false;
    if (! (await this.isAllowed())) return false;

    new Notification(title, options);

    return false;
  },
};
